'use client';

import { c as _c } from "react/compiler-runtime";
import Button from '../common/Button';
import { ModalContent, ModalFooter } from '../HOC/Modal';
function SessionLogoutConfirmation(t0) {
  const $ = _c(8);
  const {
    logoutHandler,
    allSessions,
    isLast
  } = t0;
  const t1 = `You're about to log out from ${allSessions ? "all sessions" : "this session"} ${isLast ? "This is the last session. If 2fa is enabled, it will automatically be disabled" : ""}. Are you sure you want to continue? `;
  let t2;
  if ($[0] !== t1) {
    t2 = <ModalContent><p className="text-start">{t1}</p></ModalContent>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = `End Session${allSessions ? "s" : ""}`;
  let t4;
  if ($[2] !== logoutHandler || $[3] !== t3) {
    t4 = <ModalFooter><Button text={t3} classNames="w-28 self-end" onClick={logoutHandler} /></ModalFooter>;
    $[2] = logoutHandler;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t2 || $[6] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[5] = t2;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}
export default SessionLogoutConfirmation;